import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionFormLayout from '../../../../../components/layouts/actions/ActionFormLayouts';
import NumberInput from '../../../../../components/customForm/number/NumberInput';
import TeamChoice from '../../../../../components/customForm/teamchoice/TeamChoice';
import Title from '../../../../../components/Title';
import { withRouter } from 'react-router-dom';
import { LOGO_TEAM_URL } from '../../../../../config.env';
import { fetchLive, addActionLive, editActionLive } from '../../../../../actions/liveDataActions';
import { List } from 'antd-mobile';
import _ from 'lodash';
import queryString from 'query-string';
import { getChronoFromLiveDebut } from '../../../../../helpers';
import { addAction } from '../../../../../services/live';
import { editAction } from '../../../../../services/action';

class SubstitutionFormPage extends Component {

    constructor(props) {
        super(props);

        const qs = queryString.parse(this.props.history.location.search);
        const dataEdited = qs.action_edit ? JSON.parse(qs.action_edit) : null;
        const min = qs.actions ? parseInt(getChronoFromLiveDebut(JSON.parse(qs.actions))) : 0;

        this.state = {
            team: dataEdited ? dataEdited.data.team : '',
            minute: dataEdited ? dataEdited.minute || 0 : min,
            showBtnSubmit: true,
            isOnSubmit: false,
            teamName: dataEdited ? dataEdited.data.teamName : '',
            match: {},
            playerIn: dataEdited ? dataEdited.data.playerIn : null,
            playerOut: dataEdited ? dataEdited.data.playerOut : null,
            formValid: true
        }

        this.id = this.props.match.params.id;
        this.actionId = qs.action_type ? JSON.parse(qs.action_type)['@id'] : '';
        this.editId = dataEdited ? dataEdited['@id'] : ''
    }

    componentDidMount() {
        this.props.fetchLive(this.id, this.props.connexionReducer).then(() => this.setState({match: this.props.liveDataReducer[`/api/lives/${this.id}`].match}));
    }

    submit() {
        const {teamName, playerIn, playerOut, team, minute} = this.state;
        this.setState({formValid: false, isOnSubmit: true});
        const dataAction = {
            label: 'remplacement',
            actionName: `Remplacement pour ${teamName}`,
            description: playerOut ? `Sortie du n°${playerOut}` : '',
            other: playerIn ? `Entrée du n°${playerIn}` : '',
            team,
            teamName,
            playerOut,
            playerIn
        }

        if(this.editId && this.editId !== '') {
            editAction(this.editId, {
                teamId: parseInt(team),
                teamName,
                minute: parseInt(minute),
                data: dataAction
            }, this.props.connexionReducer, this.id, this.actionId).then(response => {
                this.setState({isOnSubmit: false});
                this.props.editActionLive(this.id, response.data);
                this.props.history.push(`/live/${this.id}`);
            })
        }
        else {
            addAction(this.id, {
                type: this.actionId,
                teamId: parseInt(team),
                teamName,
                minute: parseInt(minute),
                data: dataAction
            }, this.props.connexionReducer).then(response => {
                window.postMessage(JSON.stringify({
                action: 'trackEvent',
                parameters: {
                    label: 'added_live_score',
                    value: 'déclarer un remplacement'
                }
            }), '*');
                this.setState({isOnSubmit: false});
                this.props.addActionLive(this.id, response.data);
                this.props.history.push(`/live/${this.id}`)
            })
        }
    }

    render() {
        const {team, minute, showBtnSubmit, isOnSubmit, match, playerOut, playerIn, formValid} = this.state;
        return (
            <ActionFormLayout
                title='Remplacement'
                submit={this.submit.bind(this)}
                enabled={ formValid && team !== '' && minute !== '' && minute !== null && !_.isNaN(minute)}
                showBtn={showBtnSubmit}
                isOnSubmit={isOnSubmit}
            >
                <div className='ls_debut_form'>
                    <TeamChoice 
                        header={() => <Title text='remplacement demandé par' />}
                        teams={[
                            {icon: `${LOGO_TEAM_URL}/${match.homeTeamClCod}.jpg`, text: match.homeTeam, teamId: match.homeTeamClCod, name: match.homeTeamEqName},
                            {icon: `${LOGO_TEAM_URL}/${match.awayTeamClCod}.jpg`, text: match.awayTeam, teamId: match.awayTeamClCod, name: match.awayTeamEqName}
                        ]}
                        teamName={team}
                        onChange={(team, teamName) => this.setState({team, teamName})}
                    />
                    <List renderHeader={() => <Title text='détails du remplacement' />}>
                        <NumberInput 
                            label='Minute'
                            min={0}
                            value={minute}
                            defaultValue={minute}
                            onChange={min => this.setState({minute: min})}
                            id='ls_minute_remplacement'
                            onFocus={() => this.setState({showBtnSubmit: false})}
                            onBlur={() => this.setState({showBtnSubmit: true})}
                        />
                    </List>
                    <List renderHeader={() => <Title text='informations optionnelles' />}>
                        <NumberInput 
                            label='Joueur sortant (n° maillot)'
                            placeholder='à renseigner'
                            min={1}
                            max={99}
                            value= {playerOut}
                            defaultValue={playerOut}
                            onChange={v => this.setState({playerOut: v})}
                            id='ls_out_player'
                            onFocus={() => this.setState({showBtnSubmit: false})}
                            onBlur={() => this.setState({showBtnSubmit: true})}
                        />
                        <NumberInput 
                            label='Joueur entrant (n° maillot)'
                            placeholder='à renseigner'
                            min={1}
                            max={99}
                            value={playerIn}
                            defaultValue={playerIn}
                            onChange={v => this.setState({playerIn: v})}
                            id='ls_in_player'
                            onFocus={() => this.setState({showBtnSubmit: false})}
                            onBlur={() => this.setState({showBtnSubmit: true})}
                        />
                    </List>
                </div>
            </ActionFormLayout>
        )
    }
}

const mapStateToProps = ({connexionReducer,liveDataReducer}) => ({connexionReducer,liveDataReducer});

const mapDispatchToProps = dispatch => bindActionCreators({ fetchLive, addActionLive, editActionLive }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubstitutionFormPage));

